<template>
  <section class="inner">
    <h1 id="detailHd">CONTACT</h1>
    <ul id="pankuzu" class="flex flex-left">
      <li><a href="/" class="opacity">ホーム</a></li>
      <li>お問い合わせ</li>
    </ul>
    <section id="detailInner">
      <h2 id="formHd">お問合せフォーム</h2>
      <div id="formInner">
        <div v-if="isSent">
          <p class="text">送信いたしました。<br class="sp-show">ありがとうございました。</p>
        </div>
        <div v-else>
          <form  @submit.prevent="onSubmit" novalidate="true">
            <table id="contactForm">
              <tr>
                <th class="required">お名前</th>
                <td>
                  <div class="flex flex-align">
                    <dl class="halfBox flex flex-align">
                      <dt>姓</dt>
                      <dd><input type="text" v-model="form.lastName" class="form-input"></dd>
                    </dl>
                    <dl class="halfBox flex flex-align">
                      <dt>名</dt>
                      <dd><input type="text" v-model="form.firstName" class="form-input"></dd>
                    </dl>
                  </div>
                  <p v-for="(error, index) in errors.name" :key="index" class='error pl'><span>{{ error }}</span></p>
                </td>
              </tr>
              <tr>
                <th class="free">法人名</th>
                <td class="pl">
                  <input type="text" v-model="form.company" class="form-input">
                  <p v-for="(error, index) in errors.company" :key="index" class='error'><span>{{ error }}</span></p>
                </td>
              </tr>
              <tr>
                <th class="required">メールアドレス</th>
                <td class="pl">
                  <input type="email" v-model="form.email" class="form-input">
                  <p v-for="(error, index) in errors.email" :key="index" class='error'><span>{{ error }}</span></p>
                </td>
              </tr>
              <tr>
                <th class="required">お問い合わせ内容</th>
                <td class="pl">
                  <textarea v-model="form.detail" class="form-textarea"></textarea>
                  <p v-for="(error, index) in errors.detail" :key="index" class='error'><span>{{ error }}</span></p>
                </td>
              </tr>
            </table>
            <input type="submit" v-bind:value="submitBtnTitle" id="submitBtn" v-bind:disabled="isSubmitDisabled">
            <p v-for="(error, index) in errors.submit" :key="index" class='error error-submit'><span>{{ error }}</span></p>
            <vue-recaptcha
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              size="invisible"
              v-bind:sitekey="recaptchaSitekey"
              v-bind:loadRecaptchaScript="true"></vue-recaptcha>
          </form>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import Axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Contact',
  data () {
    return {
      recaptchaSitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
      isSent: false,
      isSubmitDisabled: false,
      submitBtnTitle: '',
      form: {
        lastName: '',
        firstName: '',
        company: '',
        email: '',
        detail: '',
        verify: ''
      },
      errors: {
        name: [],
        company: [],
        email: [],
        detail: [],
        submit: []
      }
    }
  },
  components: {
    VueRecaptcha
  },
  filters: {
    whitespace: function (value) {
      return value.trim()
    }
  },
  methods: {
    // 送信ボタンクリック
    onSubmit: function () {
      if (!this.validation()) {
        return false
      }
      this.isSubmitDisabled = true
      this.$refs.invisibleRecaptcha.execute()
    },
    // リクエスト成功
    successCallback: function (response) {
      if (response.data > 0) {
        this.showSendErrorInfo()
        return false
      }
      this.isSent = true

      window.scrollTo({
        top: 0,
        behavior: 'instant'
      })
    },
    // リクエスト失敗
    failedCallback: function (error) {
      this.showSendErrorInfo()
    },
    // api post
    postApi: function (url, params, success, failed) {
      Axios.post(url, params)
        .then(function (response) {
          success(response)
        })
        .catch(function (error) {
          failed(error)
        })
    },
    // 送信エラーメッセージ表示
    showSendErrorInfo: function() {
      this.errors.submit.push('送信できませんでした')
      this.isSubmitDisabled = false
    },
    // reCaptcha トークン取得 & フォームPOST
    onVerify: function (response) {
      this.form.verify = response
      this.postApi(process.env.VUE_APP_API_CONTACT, this.form, this.successCallback, this.failedCallback)
    },
    // reCaptcha エラー
    onExpired: function () {
      this.form.verify = ''
      this.errors.submit.push('reCAPTCHAでbotと判断されました')
    },
    // フォームバリデーション
    validation: function () {
      this.resetErrors()
      this.removeWhitespace()

      if (!this.form.lastName) {
        this.errors.name.push('姓を入力してください')
      } else if (this.form.lastName.length > 10) {
        this.errors.name.push('姓を10文字以内で入力してください')
      }

      if (!this.form.firstName) {
        this.errors.name.push('名を入力してください')
      } else if (this.form.firstName.length > 10) {
        this.errors.name.push('名を10文字以内で入力してください')
      }

      if (this.form.company.length > 100) {
        this.errors.company.push('100文字以内で入力してください')
      }

      if (!this.form.email) {
        this.errors.email.push('入力してください')
      } else if (this.form.email.length > 254) {
        this.errors.email.push('254文字以内で入力してください')
      } else if (!this.validEmail(this.form.email)) {
        this.errors.email.push('形式が不正です')
      }

      if (!this.form.detail) {
        this.errors.detail.push('お問い合わせ内容を入力してください')
      } else if (this.form.detail.length > 3000) {
        this.errors.detail.push('3000文字以内で入力してください')
      }

      var isValid = true
      for (var key in this.errors) {
        for (var index in this.errors[key]) {
          if (this.errors[key][index].length > 0) {
            isValid = false
          }
        }
      }
      return isValid
    },
    resetErrors: function () {
      for (var key in this.errors) {
        this.errors[key] = []
      }
    },
    removeWhitespace: function () {
      for (var key in this.form) {
        this.form[key] = this.form[key].trim()
      }
    },
    validEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  beforeRouteEnter: function (to, from, next) {
    next()
  },
  watch: {
    isSubmitDisabled: function (val) {
      if (val) {
        this.submitBtnTitle = '送信中'
      } else {
        this.submitBtnTitle = '送信'
      }
    }
  }
}
</script>

<style scoped>
  #formHd{
    width:auto;
    margin-bottom:60px;
    font-size:234%;
    line-height:44px;
    position:relative
  }

  #formHd::before{
    display:inline-block;
    vertical-align:top;
    content:"";
    width:44px;
    height:44px;
    margin-right:20px;
    background:#000 url(../assets/img/contact/icon-mail.svg) no-repeat 50%;
    background-size:22px auto;
    border-radius:50%;
  }

  #formInner{
    width:auto;
    padding:0 64px;
  }

  #contactForm{
    width:100%;
    font-size:150%;
  }

  #contactForm th{
    vertical-align:top;
    width:240px;
    text-align:left;
    line-height:50px;
    padding:36px 0 30px;
    position:relative;
  }

  #contactForm th::before{
    display:block;
    content:"";
    width:164px;
    height:1px;
    position:absolute;
    left:0;
    top:8px;
  }

  #contactForm th::after{
    display:block;
    position:absolute;
    left:174px;
    top:0px;
    font-size:13px;
    line-height:16px;
  }

  #contactForm .free::before{ background:#000;}
  #contactForm .free::after{ content:"任意";}

  #contactForm .required::before{ background:#BC284C;}
  #contactForm .required::after{
    content:"必須";
    color:#BC284C;
  }

  #contactForm td{
    vertical-align:top;
    padding:36px 0 30px;
  }

  #contactForm .pl{ padding-left:32px;}

  .form-input{
    width:100%;
    max-width:630px;
    height:50px;
    padding:0 10px;
    border:1px solid #D7D8D8;
    box-sizing:border-box;
    border-radius:0;
  }

  .form-textarea{
    width:100%;
    max-width:630px;
    height:230px;
    padding:10px;
    border:1px solid #D7D8D8;
    box-sizing:border-box;
    resize:none;
    overflow:auto;
    border-radius:0;
  }

  .halfBox{ width:calc(50% - 10px);}
  .halfBox dt{ width:32px;}
  .halfBox dd{ width:calc(100% - 32px);}

  .text{
    width:100%;
    text-align:center;
    font-size:134%;
    font-weight: bold;
    margin: 120px 0 100px 0;
  }

  #submitBtn{
    display:block;
    width:290px;
    height:50px;
    margin:60px auto 0;
    border:none;
    outline:none;
    color:#000;
    font-size:150%;
    cursor:pointer;
    background:#F3D22D;
    border-radius:5px;
    transition:all 0.2s ease-out;
  }

  #submitBtn:hover{
    color:#F3D22D;
    background:#000;
  }

  .error{
    clear:both;
    padding-top:8px;
  }

  .error span{
    display:inline-block;
    padding:5px;
    font-weight:bold;
    font-size:12px;
    color:#fff;
    background:#BC284C;
    border-radius:4px;
  }

  .error-submit {
    text-align: center;
  }

  /*------------------------------------------------------------
      MediaQuery
  ------------------------------------------------------------*/

  /* PC */
  @media screen and (max-width: 1180px) and (min-width: 835px){

    #formHd{
      margin-bottom:5.084745762711864vw;
      font-size:2.372881355932203vw;
      line-height:3.728813559322034vw;
    }

    #formHd::before{
      width:3.728813559322034vw;
      height:3.728813559322034vw;
      background-size:1.864406779661017vw auto;
      margin-right:1.694915254237288vw;
    }

    #formInner{ padding:0 5.423728813559322vw;}

    #contactForm{ font-size:1.525423728813559vw;}

    #contactForm th{
      width:20.33898305084746vw;
      line-height:4.23728813559322vw;
      padding:3.050847457627119vw 0 2.542372881355932vw;
    }

    #contactForm th::before{
      width:13.89830508474576vw;
      top:0.6779661016949153vw;
    }

    #contactForm th::after{
      line-height:1.355932203389831vw;
      left:14.74576271186441vw;
      font-size:1.101694915254237vw;
    }

    #contactForm td{ padding:3.050847457627119vw 0 2.542372881355932vw;}

    #contactForm .pl{ padding-left:2.711864406779661vw;}

    .form-input{
      max-width:53.38983050847458vw;
      height:4.23728813559322vw;
      padding:0 0.8474576271186441vw;
    }

    .form-textarea{
      max-width:53.38983050847458vw;
      height:19.49152542372881vw;
      padding:0.8474576271186441vw;
    }

    .halfBox{ width:calc(50% - 0.8474576271186441vw);}
    .halfBox dt{ width:2.711864406779661vw;}
    .halfBox dd{ width:calc(100% - 2.711864406779661vw);}

    .text{ font-size:1.355932203389831vw;}

    #submitBtn{
      width:24.57627118644068vw;
      height:4.23728813559322vw;
      margin-top:5.084745762711864vw;
      font-size:1.525423728813559vw;
      border-radius:0.423728813559322vw;
    }

    .error{ padding-top:0.6779661016949153vw;}

    .error span{
      padding:0.423728813559322vw;
      font-size:1.016949152542373vw;
      border-radius:0.3389830508474576vw;
    }
  }


  /* TABLET */
  @media screen and (max-width: 834px){

    #formHd{
      margin-bottom:40px;
      font-size:175%;
      line-height:36px;
      text-align:center;
    }

    #formHd::before{
      width:36px;
      height:36px;
      margin-right:16px;
      background-size:18px auto;
    }

    #formInner{ padding:0;}

    #contactForm{ font-size:134%;}

    #contactForm th{ width:180px;}

    #contactForm th::before{ width:130px;}
    #contactForm th::after{ left:140px;}

    .text{
      width:100%;
      text-align:center;
      font-size:117%;
    }

    #submitBtn{ font-size:134%;}
  }


  /* SP */
  @media screen and (max-width: 480px){

    #formHd{
      margin-bottom:30px;
      font-size:150%;
      line-height:32px;
      text-align:center;
    }

    #formHd::before{
      width:32px;
      height:32px;
      margin-right:12px;
      background-size:16px auto;
    }

    #contactForm{ font-size:117%;}

    #contactForm,
    #contactForm thead,
    #contactForm tbody,
    #contactForm tr,
    #contactForm th,
    #contactForm td{ display:block;}

    #contactForm tr + tr{ margin-top:20px;}

    #contactForm th{
      width:auto;
      line-height:1.5;
      padding: 28px 0 14px;
    }

    #contactForm th::before{ width:110px;}
    #contactForm th::after{
      left:120px;
      font-size:12px;
    }

    #contactForm td{ padding:0;}
    #contactForm .pl{ padding-left:0;}

    .form-input{ height:40px;}
    .form-textarea{ height:180px;}

    .halfBox { width:100%;}
    .halfBox +  .halfBox { margin-top:14px;}
    .halfBox dt{ width:24px;}
    .halfBox dd{ width:calc(100% - 24px);}

    .text{
      font-size:100%;
      margin-top:80px;
    }

    #submitBtn{
      width:220px;
      height:40px;
      margin-top:40px;
      font-size:117%;
    }
  }
</style>
